namespace SSi.Blazor.Common.Shared.Wasm.StorageTest {
    // ReSharper disable once InconsistentNaming
    declare var DotNet: any;
    declare var localforage: any;
    var localforageStore: any;

    let storageTestAssembly = "SSi.Blazor.Common.Shared.Wasm";

    //Setup test data
    var chunkSize = 100 * 1024; //100kB chunks
    var maxSize = 1024 * 1024 * 1024; //1GB
    var chunkContent = (new Array(chunkSize + 1)).join("a");
    chunkSize = chunkContent.length;
    var loops = maxSize / chunkSize;

    var localStorageSize: number;
    var localStorageFilled: boolean;
    var sessionStorageSize: number;
    var sessionStorageFilled: boolean;
    var localforageSize: number;
    var localforageFilled: boolean;
    var chunkNamePrefix = "CapabilityTestChunk";


    async function dispatchStorageTestResponse(requestId: string, size: number, filled: boolean, error: string): Promise<void> {
        await DotNet.invokeMethodAsync(storageTestAssembly, "StorageTestResponse", requestId, size, filled, error);
    }

    export function runLocalStorageTest(requestId: string) {
        try {
            // Init the Storage
            localStorageSize = 0;
            localStorageFilled = false;
            clearLocalStorageTestFiles();

            try {
                for (let i = 0; i < loops; i++) {
                    if (localStorageFilled) {
                        break;
                    }
                    var keyName = `${chunkNamePrefix}${i}`;
                    saveChunkToLocalStorage(keyName, chunkContent);
                    localStorageSize += chunkContent.length;
                }
            } finally {
                clearLocalStorageTestFiles();
            }

            dispatchStorageTestResponse(requestId, localStorageSize, localStorageFilled, "");


        } catch (ex) {
            console.log(ex);
        }
    }

    export function runSessionStorageTest(requestId: string) {
        try {
            // Init the Storage
            sessionStorageSize = 0;
            sessionStorageFilled = false;
            clearSessionStorageTestFiles();

            try {
                for (let i = 0; i < loops; i++) {
                    if (sessionStorageFilled) {
                        break;
                    }
                    var keyName = `${chunkNamePrefix}${i}`;
                    saveChunkToSessionStorage(keyName, chunkContent);
                    sessionStorageSize += chunkContent.length;
                }
            } finally {
                clearSessionStorageTestFiles();
            }

            dispatchStorageTestResponse(requestId, sessionStorageSize, sessionStorageFilled, "");



        } catch (ex) {
            console.log(ex);
        }
    }

    export function runLocalForageTest(requestId: string) {
        try {
            if (localforageStore == null) {
                localforageStore = localforage.createInstance({
                    name: "TestStorage"
                });
            }

            // Init the Localforage
            localforageStore.clear();

            localforageSize = 0;
            localforageFilled = false;
            clearLocalForageTestFiles();

            try {
                for (let i = 0; i < loops; i++) {
                    if (localforageFilled) {
                        break;
                    }
                    var keyName2 = `${chunkNamePrefix}${i}`;
                    saveChunkToLocalforage(keyName2, chunkContent);
                    localforageSize += chunkContent.length;
                }
            } finally {
                //clearLocalForageTestFiles();
                localforageStore.clear();
            }

            dispatchStorageTestResponse(requestId, localforageSize, localforageFilled, "");



        } catch (ex) {
            console.log(ex);
        }
    }

    function saveChunkToLocalStorage(key: string, data: string) {
        try {
            localStorage.setItem(key, data);
        } catch (e) {
            if (e.name === 'QuotaExceededError' ||
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                localStorageFilled = true;
                console.log(`Storage Limit Reached, ${e.name}`);
            } else {
                //console.error(e);
                console.log(e);
            }
        }
    }

    function saveChunkToSessionStorage(key: string, data: string) {
        try {
            sessionStorage.setItem(key, data);
        } catch (e) {
            if (e.name === 'QuotaExceededError' ||
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                sessionStorageFilled = true;
                console.log(`Storage Limit Reached, ${e.name}`);
            } else {
                //console.error(e);
                console.log(e);
            }
        }
    }

    function saveChunkToLocalforage(key: string, data: string) {
        try {
            localforageStore.setItem(key, data);
        } catch (e) {
            if (e.name === 'QuotaExceededError' ||
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                localforageFilled = true;
                console.log(`Storage Limit Reached, ${e.name}`);
            } else {
                //console.error(e);
                console.log(e);
            }
        }
    }


    // ReSharper disable once UnusedLocals
    export function clearLocalStorage() {
        try {
            localStorage.clear();
        } catch (ex) {
            console.log(ex);
        }
    }

    export function clearSessionStorage() {
        try {
            sessionStorage.clear();
        } catch (ex) {
            console.log(ex);
        }
    }

    // ReSharper disable once UnusedLocals
    export function clearLocalforage() {
        try {
            if (localforageStore == null) {
                localforageStore = localforage.createInstance({
                    name: "TestStorage"
                });
            }
            localforageStore.clear();
        } catch (ex) {
            console.log(ex);
        }
    }

    export function clearLocalStorageTestFiles() {
        try {
            clearStorageTestFiles(localStorage);
        } catch (ex) {
            console.log(ex);
        }
    }

    export function clearSessionStorageTestFiles() {
        try {
            clearStorageTestFiles(sessionStorage);
        } catch (ex) {
            console.log(ex);
        }
    }

    export function clearLocalForageTestFiles() {
        try {
            clearStorageTestFiles(localforageStore);
        } catch (ex) {
            console.log(ex);
        }
    }

    function clearStorageTestFiles(storage) {
        if (storage == null) {
            console.log("clearStorageTestFiles missing storage");
            return;
        }
        const length = storage.length;
        var toRemove = [];

        for (let i = 0; i < length; i++) {
            try {
                var keyName = storage.key(i);
                if (keyName.startsWith(chunkNamePrefix)) {
                    toRemove.push(keyName);
                }
            } catch (ex1) {
                //console.error(e);
                console.log(ex1);
            }
        }

        for (let i = 0; i < toRemove.length; i++) {
            try {
                var keyName2 = toRemove[i];
                storage.removeItem(keyName2);
            } catch (ex2) {
                //console.error(e);
                console.log(ex2);
            }
        }
    }

}
